import React, { useMemo } from 'react';
import { Column } from 'react-table';
import useSyncOrder from '@/hooks/useSyncOrder';
import { useToggle } from '@/hooks/useToggle';
import { ReorderableDndTable } from '@/components/basic';
import { IHourWithResName } from '@/components/hours/rule/ListHoursRules';

export interface HourRulesTableViewProps {
  columns: Column<IHourWithResName>[];
  list: IHourWithResName[] | undefined;
  updateFunction:
    | ((hour: IHourWithResName, newWeight: number) => Promise<void>)
    | null;
  invalidateQuery: () => Promise<void>;
  reorderable?: boolean;
}

export function HourRulesTableView({
  columns,
  list,
  updateFunction,
  invalidateQuery,
  reorderable = false
}: HourRulesTableViewProps) {
  const [, toggleCreateOpen] = useToggle(false);
  const tableColumns = useMemo<HourRulesTableViewProps['columns']>(
    () => columns,
    [list, columns]
  );
  const {
    orderedList: tableData,
    keysInOrder,
    setKeysInOrder
  } = useSyncOrder<IHourWithResName>(list);

  return (
    <>
      <div className="flex flex-auto flex-col overflow-y-auto">
        <ReorderableDndTable
          weightScaleFactor={10}
          className="mt-2"
          reorderable={reorderable}
          listItemsKeys={keysInOrder}
          setListItemsKeys={setKeysInOrder}
          updateFunction={updateFunction}
          tableColumns={tableColumns}
          tableData={tableData}
          tableId="table-HourRules"
          emptyActionCta={toggleCreateOpen}
          emptyDescription="You haven't added any Hour yet."
          emptyAction="Start adding a Hour now!"
        />
      </div>
    </>
  );
}
